import { SelectButton } from "@shared/ui/Select";
import { SelectButtonProps } from "@shared/ui/Select/SelectButton";
import { Card, Divider, Input, InputProps, Space } from "antd";
import React from "react";

export default function SearchWithFilters({
  inputProps,
  selectProps,
}: {
  inputProps: InputProps;
  selectProps?: SelectButtonProps[];
}) {
  const hasSelects = selectProps && selectProps.length > 0;

  return (
    <Card styles={{
        body: {
            padding: 0
        },
    }}>
    <Input
      {...inputProps}
      variant="borderless"
      styles={{
        input: {
            minWidth: 150,
        },
      }}
      suffix={
        hasSelects ? (
          <Space.Compact style={{ display: "flex", alignItems: "center" }}>
            <Divider
              type="vertical"
              style={{ height: "20px", margin: "0 8px 0 4px" }}
            />
            {selectProps.map((val, idx) => (
              <React.Fragment key={idx}>
                <SelectButton {...val} />
                {idx < selectProps.length - 1 && (
                  <Divider
                    type="vertical"
                    style={{ height: "16px", margin: "0 8px" }}
                  />
                )}
              </React.Fragment>
            ))}
          </Space.Compact>
        ) : undefined
      }
    />
    </Card>
  );
}